import { Notification } from '../services'
import { IDUtils } from '../utils'

const initialState = {
    flashMessages: [],
    messages: [],
}

const addNotification = (state, { title = '', body = '', isDismissible = false, callback = null }) => ({
    ...state,
    messages: [
        ...state.messages,
        {
            id: IDUtils.generateID(),
            title,
            body,
            isDismissible,
            callback,
            obj: new Notification(title, { body }),
        },
    ],
})

export default (state = initialState, { type, payload = {}, meta = {} }) => {
    switch (type) {
        case 'persist/REHYDRATE':
            return {
                ...initialState,
            }
        case 'NOTIFY_FLASH_MESSAGE': {
            return {
                ...state,
                flashMessages: [
                    {
                        id: IDUtils.generateID(),
                        message: payload.message,
                    },
                ],
            }
        }
        case 'NOTIFY_MESSAGE': {
            return addNotification(state, {
                title: payload.title,
                body: payload.body,
                isDismissible: payload.isDismissible,
                callback: payload.callback,
            })
        }
        case 'DISMISS_MESSAGE': {
            return {
                ...state,
                messages: state.messages.filter(({ id }) => id !== payload.id),
            }
        }
        case 'DISMISS_ALL_MESSAGES': {
            return {
                ...state,
                messages: state.messages.filter(({ isDismissible }) => !isDismissible),
            }
        }
        case 'DISMISS_FLASH_MESSAGE': {
            return {
                ...state,
                flashMessages: state.flashMessages.filter(({ id }) => id !== payload.id),
            }
        }
        case 'CONTENT_PUSH_CREATE##SUCCESS': {
            const { id, name } = payload
            return addNotification(state, {
                title: 'New Content Push',
                body: `Content push item ${id} ${name} has been created`,
                isDismissible: true,
            })
        }
        case 'CONTENT_PUSH_EDIT##SUCCESS': {
            const { id, name } = payload
            return addNotification(state, {
                title: 'Item Updated',
                body: `Content push item ${id} ${name} has been edited`,
                isDismissible: true,
            })
        }
        case 'DEVICE_CONNECTION_SOCKET': {
            if (!meta.withNotification) {
                return state
            }

            const { id: uid, store_code: storeCode, store: { name: storeName } = {} } = payload
            return addNotification(state, {
                title: 'Device online',
                body: `Device ${uid} at ${storeName} (${storeCode}) has connected.`,
                isDismissible: true,
            })
        }
        case 'DEVICE_DISCONNECTION_SOCKET': {
            if (!meta.withNotification) {
                return state
            }

            const { id } = payload

            return addNotification(state, {
                title: 'Device offline',
                body: `Device ${id} disconnected.`,
                isDismissible: true,
            })
        }
        case 'UPLOAD_FILE##FAILURE': {
            const { message } = payload

            return addNotification(state, {
                title: 'Upload failure',
                body: message,
                isDismissible: true,
            })
        }
        default:
            return state
    }
}
